import React, { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../User/UserSettings/UserContext"

interface LoginGuardProps {
    children: ReactNode;
}

const LoginGuard: React.FC<LoginGuardProps> = ({ children }) => {
    const { user } = useContext(UserContext) || { user: null };
    
    if (!user || !user.token) {
        console.log('LoginGuard - Redirecting to login because no user or token');
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default LoginGuard;